(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------------------------------------------------------------
  // Reveal on scroll — re-observa cada vez que una sección se (re)carga,
  // para que funcione tanto en el sitio real como dentro del editor de
  // temas de Shopify (que reemplaza el HTML de una sección sin recargar
  // la página cuando cambias una configuración).
  // ---------------------------------------------------------------
  var revealIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        revealIO.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  function initReveal(scope) {
    var els = scope.querySelectorAll('.reveal:not(.in)');
    els.forEach(function (el) {
      revealIO.observe(el);
      // Seguro de respaldo: si por lo que sea el observer nunca dispara
      // (p. ej. algún caso raro dentro del editor), se muestra de todos
      // modos después de 1.2s en vez de quedar invisible para siempre.
      setTimeout(function () { el.classList.add('in'); }, 1200);
    });
  }

  // ---------------------------------------------------------------
  // Header: estado de scroll + estado "sobre imagen"
  // ---------------------------------------------------------------
  function initHeader(scope) {
    var header = scope.querySelector ? scope.querySelector('#site-header') : null;
    if (!header && scope.id === 'site-header') header = scope;
    if (!header) header = document.getElementById('site-header');
    if (!header) return;

    var heroHasMedia = !!document.querySelector('.hero.has-media, .page-hero.has-media');

    function updateHeaderState() {
      var scrolled = window.scrollY > 30;
      header.classList.toggle('scrolled', scrolled);
      header.classList.toggle('on-media', heroHasMedia && !scrolled);
    }
    updateHeaderState();
    window.addEventListener('scroll', updateHeaderState, { passive: true });

    var burger = header.querySelector('#burgerBtn');
    var navLinks = header.querySelector('#navLinks');
    if (burger && navLinks && !burger.dataset.bound) {
      burger.dataset.bound = 'true';
      burger.addEventListener('click', function () {
        var open = navLinks.classList.toggle('open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  // ---------------------------------------------------------------
  // Hero: frase fija con palabra clave que rota + fondo tipo carrusel
  // ---------------------------------------------------------------
  function initHero(scope) {
    var heroSection = scope.querySelector ? scope.querySelector('.hero') : null;
    if (!heroSection) return;
    if (heroSection.dataset.bound) return;
    heroSection.dataset.bound = 'true';

    var keywords = Array.prototype.slice.call(heroSection.querySelectorAll('h1 .kw'));
    var rotSub = heroSection.querySelector('#rotSub');
    var dots = heroSection.querySelectorAll('.hero-dots .dot');
    var slideCount = dots.length || keywords.length;
    if (!rotSub || !slideCount) return;

    var subs = window.heroSubs || [];
    var speed = parseInt(heroSection.dataset.autoplay, 10) || 4600;
    var i = 0;

    function renderSlide(idx) {
      keywords.forEach(function (k) { k.classList.add('active'); });
      if (subs[idx] !== undefined) {
        rotSub.classList.add('swap');
        setTimeout(function () {
          rotSub.textContent = subs[idx];
          rotSub.classList.remove('swap');
        }, 350);
      }
      dots.forEach(function (d) { d.classList.remove('active'); });
      if (dots[idx]) dots[idx].classList.add('active');
      heroSection.querySelectorAll('.hero-bg-layer').forEach(function (layer) {
        layer.classList.remove('active');
      });
      var activeLayer = heroSection.querySelector('#heroLayer-' + idx);
      if (activeLayer) activeLayer.classList.add('active');
    }

    var timer;
    function next() { i = (i + 1) % slideCount; renderSlide(i); }
    if (!reduceMotion && slideCount > 1) timer = setInterval(next, speed);

    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () {
        i = idx; renderSlide(i);
        if (timer) clearInterval(timer);
        if (!reduceMotion) timer = setInterval(next, speed);
      });
    });
  }

  // ---------------------------------------------------------------
  // Cifras: conteo animado al entrar en pantalla
  // ---------------------------------------------------------------
  var statIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var el = entry.target;
        el.classList.add('in');
        var target = parseInt(el.dataset.target, 10) || 0;
        var suffix = el.dataset.suffix || '';
        var numEl = el.querySelector('[data-count]');
        var duration = 1300;
        var startTime = performance.now();
        function tick(now) {
          var p = Math.min((now - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = Math.round(target * eased);
          if (numEl) numEl.textContent = val.toLocaleString('es-MX') + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
        statIO.unobserve(el);
      }
    });
  }, { threshold: 0.4 });

  function initStats(scope) {
    var els = scope.querySelectorAll('.stat-callout');
    els.forEach(function (el) {
      if (el.dataset.counted) return;
      el.dataset.counted = 'true';
      statIO.observe(el);
    });
  }

  // ---------------------------------------------------------------
  // Flujo de servicios: camión que avanza con el scroll
  // ---------------------------------------------------------------
  function initFlow(scope) {
    var flowSection = scope.querySelector ? scope.querySelector('#flow-section') : null;
    if (!flowSection || flowSection.dataset.bound) return;
    flowSection.dataset.bound = 'true';

    var flowTrack = flowSection.querySelector('.flow-track');
    var flowTruck = flowSection.querySelector('#flowTruck');
    var flowFill = flowSection.querySelector('#flowFill');
    var flowStops = flowSection.querySelectorAll('.flow-stop');
    if (!flowTrack || !flowTruck || !flowFill) return;

    function updateFlow() {
      var rect = flowTrack.getBoundingClientRect();
      var vh = window.innerHeight;
      var start = vh * 0.82;
      var end = vh * 0.22 - rect.height;
      var progress = (start - rect.top) / (start - end);
      progress = Math.max(0, Math.min(1, progress));
      var pct = progress * 100;
      flowTruck.style.left = pct + '%';
      flowFill.style.width = pct + '%';
      flowStops.forEach(function (stop) {
        var idx = parseInt(stop.dataset.stop, 10);
        var threshold = idx === 0 ? 0.04 : idx === 1 ? 0.46 : 0.9;
        stop.classList.toggle('active', progress >= threshold);
      });
    }
    if (window.matchMedia('(min-width:761px)').matches) {
      window.addEventListener('scroll', updateFlow, { passive: true });
      window.addEventListener('resize', updateFlow);
      updateFlow();
    }
  }

  // ---------------------------------------------------------------
  // Acordeón de catálogo
  // ---------------------------------------------------------------
  function initAccordion(scope) {
    scope.querySelectorAll('.acc-head').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', function () {
        var item = btn.parentElement;
        var body = item.querySelector('.acc-body');
        var wasOpen = item.classList.contains('open');
        var accordion = item.closest('.accordion') || document;
        accordion.querySelectorAll('.acc-item').forEach(function (i) {
          i.classList.remove('open');
          i.querySelector('.acc-body').style.maxHeight = null;
        });
        if (!wasOpen) {
          item.classList.add('open');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  }

  // ---------------------------------------------------------------
  // Inicializa todo dentro de un scope (documento completo o una
  // sección puntual que Shopify acaba de inyectar/recargar)
  // ---------------------------------------------------------------
  function initAll(scope) {
    initReveal(scope);
    initHeader(scope);
    initHero(scope);
    initStats(scope);
    initFlow(scope);
    initAccordion(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  // Theme editor: Shopify dispara este evento en la sección cada vez
  // que se (re)carga — al entrar al editor y cada vez que cambias una
  // configuración o agregas/quitas un bloque.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
